import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SiteUserListStore } from "../../store/SiteUserListStore";

type SiteUserListDialogsProps = {
  store: SiteUserListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de User.
 * Separado para mantener SiteUserListPage más limpio.
 */
export const SiteUserListDialogs: React.FC<SiteUserListDialogsProps> = observer(
  ({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />

        {/* Dialog de confirmación de borrado individual: mientras consulta si se
          puede borrar, el Ok espera; si el registro está en uso, dice por qué y
          solo ofrece Cerrar. */}
        <ConfirmCancelDialog
          open={store.confirmDeleteDialogOpened}
          title={store.confirmDeleteTitle}
          description={store.confirmDeleteDescription}
          onConfirm={() =>
            store.deleteCheck === "blocked"
              ? store.closeConfirmDeleteDialog()
              : store.confirmOkDelete()
          }
          onCancel={() => store.closeConfirmDeleteDialog()}
          onClose={() => store.closeConfirmDeleteDialog()}
          confirmLabel={
            store.deleteCheck === "blocked" ? langStore.closeCommand : undefined
          }
          hideCancelButton={store.deleteCheck === "blocked"}
          confirmDisabled={
            store.deleteCheck === "checking" || store.deleteCheck === "deleting"
          }
          cancelDisabled={
            store.deleteCheck === "deleting" && !store.deleteStuck
          }
        />

        {/* Dialog de confirmación de reset password (solo User) */}
        <ConfirmCancelDialog
          open={store.resetPasswordDialogOpen}
          title={langStore.confirmRestePasswordTitle}
          description={langStore.confirmRestePasswordDescription}
          onConfirm={() => store.resetPassword()}
          onCancel={() => store.cancelResetPassword()}
          onClose={() => store.cancelResetPassword()}
        />
      </>
    );
  }
);
